import { useState, useEffect } from 'react'

export function useIsMobile() {
  const [mobile, setMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  )
  useEffect(() => {
    const handler = () => setMobile(window.innerWidth < 768)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])
  return mobile
}

export function Grid({ cols = 2, gap = 16, children, style }) {
  const mobile = useIsMobile()
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: mobile ? '1fr' : `repeat(${cols}, minmax(0,1fr))`,
      gap,
      ...style,
    }}>
      {children}
    </div>
  )
}

export function Grid4({ children, gap = 12, style }) {
  const mobile = useIsMobile()
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: mobile ? 'repeat(2, minmax(0,1fr))' : 'repeat(4, minmax(0,1fr))',
      gap,
      ...style,
    }}>
      {children}
    </div>
  )
}

export function PagePad({ children }) {
  const mobile = useIsMobile()
  return (
    <div style={{ padding: mobile ? '16px' : '24px 32px' }}>
      {children}
    </div>
  )
}
